/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Lib_Pairing_Style_NoneInputs */



/**
* | output |
* | --- |
* | "None" |
*
* @param {Tournaments_Lib_Pairing_Style_NoneInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const tournaments_lib_pairing_style_none = /** @type {((inputs?: Tournaments_Lib_Pairing_Style_NoneInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Lib_Pairing_Style_NoneInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("无")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("無")
	if (locale === "ko") return /** @type {LocalizedString} */ ("없음")
	return /** @type {LocalizedString} */ ("None")
});